import styled from 'styled-components'
import { ThemeUIStyleObject } from '@theme-ui/css'
import { Icon, theme } from '@dasa-health/components-react'

export const Container = styled.div`
    width: 100vw;
    padding: 2rem 1rem 2rem 1rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin: 3.0625rem auto 4rem;
        max-width: calc(100vw - 150px);
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        margin: 2.5rem auto 4rem;
        max-width: 54.5rem;
    }
`

export const StylizedParagraphs = {
    fontWeight: '400',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
} as const

export const CustomIcon = styled(Icon)`
    &&& {
        padding: 0;
        margin: 0.125rem 0.5625rem auto 0;
        font-weight: 700;
    }
`

export const FlexLinksContainer: ThemeUIStyleObject = {
    maxWidth: '100%',
    justifyContent: 'space-between',
    flexDirection: ['column', 'row'],
}

export const LinksContainer = styled.div`
    margin-top: 1rem;
    display: flex;
    gap: 1rem;

    @media (max-width: 30rem) {
        flex-direction: column;
    }
`

export const SocialContainer = styled.div`
    margin-top: 1rem;
    display: flex;
    gap: 1rem;
`
